import { useDispatch, useSelector } from "react-redux";

import {
  outAuditory,
  useAuditory,
  withSuccessPayment,
} from "@/auditory/provider/hooks";
import { timelog } from "@/utils/TimeLog";
import { decryptCredentials } from "@/utils/cifrate";
import helpers from "@/utils/helpers";
import { saveLeadData } from "@/redux/actions/vida";
import { useSendEmail } from "./useSendEmail";
import { logsAuditory, setErrorLog } from "@/auditory/provider/actions";
import { CODE_VIDA_CT, StateMachine } from "@/utils/consts";
import { changeErrorData } from "@/redux/actions/global";
import { useToken } from "./useToken";
import history from "@/utils/history";
import { INACTIVE_CHECKOUT_CODES } from "../../../../../constants/inactive-checkout-codes";
import {
  CHECKOUT_MESSAGES,
  DEFAULT_MESSAGE,
  INACTIVE_MESSAGE,
} from "../../../../../constants/checkout-messages";
import { useLeadsService } from "@/services/leads.service";
import { VE_LIST_TYPE_BENEFICIARY } from "@/constants/list-type-beneficiary";
import { encrypt_AES256_2 } from "@/utils/CryptographyUtils";
import { APP_KEY_ENCRYPT } from "@/utils/awsConfig";
import { getProductOptions } from '@/utils/product'

export const useCheckout = ({
  errorStep,
  nextStep,
  initialStep,
  setModalErrorData,
}) => {
  const { digitalDataProductName } = getProductOptions();
  const { userData } = useSelector((state) => state.vida);
  const { planSelected, typeOfFinancing, nameFrequency } = useSelector(
    (state) => state.plans
  );
  const idLead = useSelector((state) => state.vida.idLead);
  const leadData = useSelector((state) => state.vida.leadData);
  const state = useSelector((state) => state.global.state);
  const currencyPlan = useSelector((state) => state.plans.currencyPlan);
  const { beneficiaryType, beneficiaries } = useSelector(
    (state) => state.beneficiaries
  );
  const { relationshipList } = useSelector((state) => state.global);
  const isEmbedded = userData.indPrevPageApp;
  const campaign = leadData?.atributos;

  const dispatch = useDispatch();
  const { dispatch: dispatchAuditory } = useAuditory();
  const { sendEmail } = useSendEmail();
  const { updateSessionToken, updateRetriesPayment } = useToken();
  const { sendLeads } = useLeadsService();

  const checkoutRpta = (response) => {
    timelog(`[CHECKOUT] CHECKOUT RPTA`, response);
    const checkoutError = localStorage.getItem("checkoutError");

    if (checkoutError) {
      return;
    }

    const requestLog = getRequestNotify();
    const localMail = userData.email || "";

    if (response.data) {
      withSuccessPayment({
        urlServicio: decryptCredentials(process.env.REACT_APP_URL_CHECKOUT),
        urlCliente: window.location?.href,
        respuestaExito: JSON.stringify(response.data),
        request: JSON.stringify({
          ...requestLog,
          checkout: {
            correo: localMail,
          },
        }),
      });

      const checkoutSuccess = localStorage.getItem("checkoutSuccess");

      if (
        isEmbedded &&
        String(campaign?.origenContenido).startsWith("clientes")
      ) {
        const amount = typeOfFinancing?.pagoMensual;
        const message = `EMBEDDED-APP-APPFLYER-PARAMS : {"revenue": "${amount}", "currency": "PEN"}`;
        const encryptedMessage = encrypt_AES256_2(message, APP_KEY_ENCRYPT);
        helpers.sendMessageToApp(encryptedMessage);
      }

      if (checkoutSuccess) {
        window.checkoutRpta = () => {
          console.log("Funcion vacia checkout...");
        };
        return;
      }

      handleSuccessfulProcess();
      window.CheckoutJS = {};
    } else if (response.error) {
      const { error = {} } = response;
      const errorCode = error.codigo ? error.codigo : error.resultado.codigo;
      const errorMessage = error.mensaje
        ? error.mensaje
        : error.resultado.mensaje;

      setErrorLog(dispatchAuditory, {
        urlServicio: decryptCredentials(process.env.REACT_APP_URL_CHECKOUT),
        urlCliente: window.location?.href,
        respuestaError: response.error,
        request: {
          ...requestLog,
          checkout: {
            correo: localMail,
          },
        },
      });

      /* helpers.getTagMetadata("Endpoint", "pago", "trackMetadata"); */
      helpers.getTagError(errorCode, errorMessage, "trackError");

      const isInactiveError = INACTIVE_CHECKOUT_CODES.find((element) => {
        return errorCode === element;
      });

      if (Number(window.intentosSesion) >= 2 && isInactiveError) {
        /* helpers.getTagError(
          errorCode,
          "Lo sentimos. El tiempo de espera se agotó",
          "trackError"
        ); */
        setModalErrorData({
          isOpen: true,
          title: INACTIVE_MESSAGE.title,
          message: INACTIVE_MESSAGE.message,
          buttonText: INACTIVE_MESSAGE.buttonText,
          icon: INACTIVE_MESSAGE.icon,
          callBack: handleGoToHome,
          close: handleGoToHome,
        });
        return;
      }

      if (isInactiveError) {
        const errorHandler = () => {
          changeErrorData({
            code: error.codigo,
            message: error.mensaje,
            step: "4",
          });
          helpers.getTagError(error.codigo, error.mensaje, "trackError");
          localStorage.setItem("checkoutError", true);
          history.push(errorStep);
        };
        updateSessionToken ? updateSessionToken(errorHandler) : errorHandler();
      }

      let currentMessage = CHECKOUT_MESSAGES.filter((item) =>
        item.code.find((element) => element === errorCode)
      )[0];

      if (!currentMessage) {
        currentMessage = DEFAULT_MESSAGE;
      }

      const retriesSuccessHandler = () => {
        setModalErrorData({
          isOpen: true,
          title: currentMessage.title,
          message: currentMessage.message,
          buttonText: currentMessage.buttonText,
          icon: currentMessage.icon,
          callBack: () => {},
          close: () => {},
        });
      };

      const retriesErrorHandler = () => {
        setTimeout(() => {
          logsAuditory(dispatchAuditory, outAuditory?.state?.auditoria, {
            paso: 2,
            pasoDescripcion: "PASO_PAGO",
            urlServicio: decryptCredentials(process.env.REACT_APP_URL_CHECKOUT),
            urlCliente: window.location?.href,
            respuestaError:
              "3 reintentos. Oh, no! Ocurrió un error técnico que no deja procesar tu pago",
            request: JSON.stringify({
              ...requestLog,
              checkout: {
                correo: localMail,
              },
            }),
          });
        }, 0);

        failedPayment();

        if (userData.indPrevPageApp) {
          helpers.sendMessageToApp("error-pago");
        }
        history.push(errorStep);
        helpers.setTrackingErrorPago(
          response.error.resultado.referencia.ideTransaccion,
          response.error.orden.numeroPedido,
          response.error.resultado.codigoExterno
        );
      };

      if (updateRetriesPayment) {
        updateRetriesPayment(retriesSuccessHandler, retriesErrorHandler);
      } else {
        window.intentos++;
        if (window.intentos >= 3) {
          retriesErrorHandler();
        } else {
          retriesSuccessHandler();
        }
      }
    }
  };

  const getRequestNotify = () => {
    return {
      tipDocumento: userData?.tipoDocumento?.toString(),
      numDocumento: userData?.numeroDocumento,
      nombre: userData?.nombres,
      apePaterno: userData?.apellidoPaterno,
      apeMaterno: userData?.apellidoMaterno,
      mail: userData?.email || userData?.coreo,
      celular: userData?.celular,
      fecInicioVigencia: planSelected?.plan?.fecIni,
    };
  };

  const handleSuccessfulProcess = async () => {
    const leadToSend = {
      ...leadData,
      idLead,
      finalizado: 5,
    };
    try {
      dispatch(saveLeadData(leadToSend));
      sendLeads(leadToSend);
      sendEmail();

      if (state !== StateMachine[4]) {
        const sumAssured = planSelected?.sumAssured?.value;
        const savingTime = planSelected?.savingTime?.value;
        const returnPercentage = planSelected?.returnPercentage?.text;
        const variant = `${sumAssured} - ${savingTime} años - ${returnPercentage} - ${helpers.capitalize(
          nameFrequency
        )}`;
        const list = beneficiaries.map((beneficiary) => {
          const relationship = relationshipList.find(
            (_) => _.id === Number(beneficiary?.relationship)
          )?.descripcion;
          return `${relationship}|${beneficiary.percentage}%`;
        });
        const { tag } =
          VE_LIST_TYPE_BENEFICIARY.find((_) => _.key === beneficiaryType) || {};
        const metadata = {
          beneficiarytype: tag,
        };

        helpers.getTagPayment({
          idQuote: `${planSelected?.idCotizacion}`,
          productAmount: `${typeOfFinancing?.valor}`,
          productCode: CODE_VIDA_CT.PRODUCT,
          variant,
          productName: "Seguro Vida Endoso con Devolución",
          metadata,
          currency: currencyPlan === "SOL" ? "Soles" : "Dólares"
        });

        if (beneficiaryType === "beneficiary-custom") {
          helpers.getTagMetadata(
            `Distribución beneficiarios exitosa ${digitalDataProductName}`,
            `${beneficiaries.length} - ${list.join(" - ")}`,
            "trackMetadata"
          );
        }

        localStorage.setItem("checkoutSuccess", true);
        return history.push(nextStep);
      }
    } catch (e) {
      if (userData.indPrevPageApp) {
        helpers.sendMessageToApp("error-pago");
      }
      return history.push(errorStep);
    }
  };

  const failedPayment = async () => {
    const leadToSend = {
      ...leadData,
      idLead,
      finalizado: 5,
    };

    await dispatch(saveLeadData(leadToSend));
    await sendLeads(leadToSend);
  };

  const handleGoToHome = () => {
    history.push(initialStep);
  };

  return { checkoutRpta };
};
